/* eslint-disable comma-dangle */
import axios from 'axios';
// Configuración de Axios
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

// eslint-disable-next-line dot-notation
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

// Sucursal activa (id o 'all'); sin valor, la API usa la sucursal por defecto del usuario.
axios.interceptors.request.use((config) => {
  const activeWorkshop = localStorage.getItem('active_workshop');

  // Un formulario puede elegir una sucursal para esta solicitud sin cambiar el filtro global.
  if (activeWorkshop && !config.headers['X-Workshop-Id']) {
    // eslint-disable-next-line no-param-reassign
    config.headers['X-Workshop-Id'] = activeWorkshop;
  }

  return config;
});

// Interceptor de errores
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[Axios] Error en la solicitud', {
      message: error.message,
      status: error.response?.status || null,
      method: error.config?.method || null,
      url: error.config?.url || null,
    });

    if (!error.response) {
      if (window.location.pathname !== '/network-error') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        localStorage.removeItem('permissions');
        localStorage.removeItem('feature_flags');
        window.dispatchEvent(new CustomEvent('app-navigation', {
          detail: { path: '/network-error' },
        }));
      }
      return Promise.reject(error);
    }

    const shouldSkipForbiddenRedirect = Boolean(error?.config?.skipForbiddenRedirect);
    const errorCode = error.response.data?.code;

    if (errorCode === 'workshop_not_assigned') {
      // La sucursal guardada ya no está asignada: volver a la sucursal por defecto.
      localStorage.removeItem('active_workshop');
      window.location.reload();
      return Promise.reject(error);
    }

    if (errorCode === 'workshop_required') {
      window.dispatchEvent(new CustomEvent('app-snackbar', {
        detail: {
          message: error.response.data.message,
          options: { color: 'warning', icon: 'mdi-map-marker-alert-outline' },
        },
      }));
    }

    if (error.response.status === 401 && window.location.pathname !== '/login') {
      // Redirigir a la página de inicio de sesión si no hay autorización
      ['token', 'user', 'role', 'permissions', 'feature_flags'].forEach((key) => {
        localStorage.removeItem(key);
      });
      window.dispatchEvent(new CustomEvent('app-navigation', {
        detail: { path: '/login' },
      }));
    }

    if (error.response.status === 429) {
      const retryAfter = error.response.headers?.['retry-after'];
      const retryMessage = retryAfter ? ` Intenta nuevamente en ${retryAfter} segundos.` : '';
      const message = error.response.data?.message
        || `Demasiadas solicitudes. Intenta nuevamente más tarde.${retryMessage}`;

      window.dispatchEvent(new CustomEvent('app-snackbar', {
        detail: {
          message,
          options: {
            color: 'error',
            icon: 'mdi-clock-alert-outline',
            source: 'network',
          },
        },
      }));
    }

    if (
      error.response
      && error.response.status === 403
      && !shouldSkipForbiddenRedirect
    ) {
      const responseData = error.response.data || {};

      sessionStorage.setItem('forbidden_error', JSON.stringify({
        message: responseData.message,
        code: responseData.code,
      }));
    }

    if (error.response && error.response.status === 503 && window.location.pathname !== '/maintenance') {
      window.dispatchEvent(new CustomEvent('app-navigation', {
        detail: { path: '/maintenance' },
      }));
    }

    return Promise.reject(error);
  }
);

export default axios;
